interface IAssistantIconProps {
  className?: string;
}

/**
 * Speech bubble with a stylized memory node inside — reads as "what the
 * assistant is remembering." Conversation + storage primitives in one
 * glyph, distinct from the chat-only debug icons in `@orn/web`. Monoline,
 * `currentColor`, no fills. Designed on a 48×48 grid.
 */
const AssistantIcon = ({ className }: IAssistantIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* speech bubble */}
    <path d="M8 10 H40 V32 H22 L14 40 V32 H8 Z" />
    {/* memory node — circle */}
    <circle cx="24" cy="21" r="3" />
    {/* memory traces — three connectors */}
    <path d="M16 21 H21" />
    <path d="M27 21 H32" />
    <path d="M24 14 V18" />
  </svg>
);

export default AssistantIcon;
